<template>
    <div id="availabilities">
        <div class="availability-subhead">
            Hours
        </div>
        <div class="hours-group" v-for="availability in availabilities" v-bind:key="availability.idAvailability">
            <div class="hours-type">
                <span v-show="availability.type === 1">Regular Hours</span>
                <span v-show="availability.type === 2">Walk-in Hours</span>
                <span v-show="availability.type === 3">Crisis Hours</span>
            </div>
            <div class="hours-days" v-show="availability.sunStart || availability.monStart || availability.tueStart || availability.wedStart || availability.thuStart || availability.friStart || availability.satStart">
                <div class="hours-day">
                    <span class="hours-label">Sun: </span>
                    <span v-show="availability.sunStart">{{availability.sunStart | timeFormat}} - {{availability.sunEnd | timeFormat}}</span>
                    <span v-show="!availability.sunStart">Closed</span>
                </div>
                <div class="hours-day">
                    <span class="hours-label">Mon: </span>
                    <span v-show="availability.monStart">{{availability.monStart | timeFormat}} - {{availability.monEnd | timeFormat}}</span>
                    <span v-show="!availability.monStart">Closed</span>
                </div>
                <div class="hours-day">
                    <span class="hours-label">Tue: </span>
                    <span v-show="availability.tueStart">{{availability.tueStart | timeFormat}} - {{availability.tueEnd | timeFormat}}</span>
                    <span v-show="!availability.tueStart">Closed</span>
                </div>
                <div class="hours-day">
                    <span class="hours-label">Wed: </span>
                    <span v-show="availability.wedStart">{{availability.wedStart | timeFormat}} - {{availability.wedEnd | timeFormat}}</span>
                    <span v-show="!availability.wedStart">Closed</span>
                </div>
                <div class="hours-day">
                    <span class="hours-label">Thu: </span>
                    <span v-show="availability.thuStart">{{availability.thuStart | timeFormat}} - {{availability.thuEnd | timeFormat}}</span>
                    <span v-show="!availability.thuStart">Closed</span>
                </div>
                <div class="hours-day">
                    <span class="hours-label">Fri: </span>
                    <span v-show="availability.friStart">{{availability.friStart | timeFormat}} - {{availability.friEnd | timeFormat}}</span>
                    <span v-show="!availability.friStart">Closed</span>
                </div>
                <div class="hours-day">
                    <span class="hours-label">Sat: </span>
                    <span v-show="availability.satStart">{{availability.satStart | timeFormat}} - {{availability.satEnd | timeFormat}}</span>
                    <span v-show="!availability.satStart">Closed</span>
                </div>
            </div>
            <div class="hours-notes" v-show="availability.notes">
                {{availability.notes}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Availabilities",
        props: ['availabilities']
    }
</script>

<style scoped>

</style>